import { createHttpEndpoint } from '../../utils'

import type { GetSellerUsers } from './seller-users-page.types'

/**
 * Get the users for a given seller (the organization).
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-users-api/definition#tag/seller-users-page/operation/get-bm-merchants-users}
 */
export const getSellerUsers = createHttpEndpoint<GetSellerUsers>({
  method: 'GET',
  operationId: 'getSellerUserList',
  path: '/bm/merchants/users',
})

/**
 * Create a new user in the given seller (the organization).
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-users-api/definition#tag/seller-users-page/operation/post-bm-merchants-users}
 */
export const postSellerUser = createHttpEndpoint({
  method: 'POST',
  operationId: 'createSellerUser',
  path: '/bm/merchants/users',
})

/**
 * Update some of the user information.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-users-api/definition#tag/seller-users-page/operation/patch-bm-merchants-users-id}
 */
export const patchSellerUser = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'updateSellerUser',
  path: '/bm/merchants/users/:userId',
})
